import { Button, Paper, Popover, Select, Skeleton, Text, TextInput, UnstyledButton } from "@mantine/core";
import { useDocumentVisibility, useInterval, useMediaQuery, useScrollIntoView, useWindowScroll } from "@mantine/hooks";
import { useEffect, useRef, useState } from "react";
import { ChevronDown, Location} from "tabler-icons-react";
import ShippingSpeed from "./Components/ShippingSpeed";
import deliverr from "./Services/deliverr";
const dayjs = require('dayjs')
dayjs().format()

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("America/New_York")

function App() {
  // pattern="[0-9]"

  const targetRef = useRef(null)
  const isMobile = useMediaQuery('(max-width: 500px)');

  const [soldOut, setSoldOut] = useState(false)
  const [zipCode, setZipCode] = useState()
  const [isOutsideUSA, setIsOutsideUSA] = useState(false)
  const [shippingSpeed, setShippingSpeed] = useState(null)
  const [variantId, setVariantId] = useState()
  const [popOverCountry, setPopOverCountry] = useState("usa")
  const [popOverZipCode, setPopOverZipCode] = useState(zipCode)
  const [popOverOpened, setPopOverOpened] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState()
  const [secondsToCutoff, setSecondsToCutoff] = useState()
  const shippingSpeedLine = useRef(null)

  const dailyCutoffOffsetHours = 3
  const interval = useInterval(() => {
    return setSecondsToCutoff((s) => s ? Math.max(s - 1, 0) : s)}, 1000);

  useEffect(() => {
    interval.start();
    //setSecondsToCutoff(1000)
    return interval.stop;
  }, []);

  const documentState = useDocumentVisibility();

  //FOR TESTING:
  //window.item={VariantID: '31066140082247'}
  

  const handleShippingSpeed = (data) => {
    
    //FOR TESTING:
    //data.deliveryDates[variantId] = '2023-01-15'
    
    if(data.serviceLevels[variantId] === 999) {

      setSoldOut(true)

    }
    else {

      setShippingSpeed(data.serviceLevels[variantId])

      if(data.minutesToCutoff < dailyCutoffOffsetHours * 60) {

        const nextShippingDayAfterToday = deliverr.getNextShippingDay(dayjs().startOf('date'))
        const daysToAddToCutoff = nextShippingDayAfterToday.diff(dayjs().startOf('date'), "d")

        //const daysToAddToCutoff = deliverr.getNextShippingDateOffset(dayjs().startOf('date'))
        const newMinutesToCutoff = (daysToAddToCutoff * 24 * 60) - (dailyCutoffOffsetHours * 60 - data.minutesToCutoff)

        setSecondsToCutoff(newMinutesToCutoff * 60)
        console.log(daysToAddToCutoff)

        const newDeliveryDate = deliverr.isShippingDay(dayjs(data.deliveryDates[variantId]).startOf('date').add(daysToAddToCutoff, 'day')) ? dayjs(data.deliveryDates[variantId]).startOf('date').add(daysToAddToCutoff, 'day') : deliverr.getNextShippingDay(dayjs(data.deliveryDates[variantId]).startOf('date').add(daysToAddToCutoff, 'day'))
        //deliverr.getNextShippingDay(dayjs(data.deliveryDates[variantId]).startOf('date').add(daysToAddToCutoff, 'day'))
        //const daysToAddToDeliveryDate = deliverr.getNextShippingDateOffset(dayjs(data.deliveryDates[variantId]).startOf('date').add(daysToAddToCutoff, 'day'))
        //console.log(daysToAddToDeliveryDate)
        setDeliveryDate(newDeliveryDate.toDate())
        //setDeliveryDate(dayjs(data.deliveryDates[variantId]).startOf('date').add(daysToAddToDeliveryDate, 'day').toDate())

      }
      else {
        const newMinutesToCutoff = data.minutesToCutoff - (dailyCutoffOffsetHours * 60)

        setSecondsToCutoff(newMinutesToCutoff * 60)

        setDeliveryDate(dayjs(data.deliveryDates[variantId]).startOf('date').toDate())
      }

    }

  }

  const handleSavePopOverInputs = (e) => {
    if(popOverCountry === "usa" && /^\d{5}?$/.test(popOverZipCode)) {
      setIsOutsideUSA(false)
      setZipCode(popOverZipCode)
      setPopOverOpened(false)
    }
    else if (popOverCountry !== "usa" ) {
      setIsOutsideUSA(true)
      setZipCode("00000")
      setPopOverOpened(false)
    }
    e.preventDefault()
  }

  function waitForElement(){
    if(typeof window.item !== "undefined"){

      setVariantId(window.item.VariantID)

    }
    else{
        setTimeout(waitForElement, 250);
    }
}

  useEffect(() => {

      const myshopify_shop_name = window.Shopify?.shop?.split(".")[0]
      const randomizationUnitId = window.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes?.uniqToken ? window.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes?.uniqToken : Math.random()
      deliverr.getZipCodeV2(myshopify_shop_name, localStorage.getItem('IH_Deliverr_Zip_Code'), randomizationUnitId).then((data) => {
        
        setZipCode(data)

        if(data === "00000") {

          setIsOutsideUSA(true)
          setPopOverCountry("outsideUS")

        }
      })
    
  }, [])

  useEffect(() => {

    if(zipCode) {
      localStorage.setItem('IH_Deliverr_Zip_Code', zipCode)
      setPopOverZipCode(zipCode)
    }

  }, [zipCode])

  useEffect(() => {

    waitForElement()

    if(zipCode && variantId) {

      setShippingSpeed(null)

      deliverr.getShippingSpeedV2(zipCode, variantId).then((data) => {
        handleShippingSpeed(data)
      })
      
    }
    
  }, [zipCode, variantId])

  useEffect(() => {

    waitForElement()

    if(zipCode && variantId) {

      //setShippingSpeed(null)

      deliverr.getShippingSpeedV2(zipCode, variantId).then((data) => {
        handleShippingSpeed(data)
      })
      
    }
    
  }, [documentState])

  return (
    <>
      {!soldOut
      ?
        <Paper style={{textAlign: "center"}} >

          <div ref={targetRef} style={{position: "relative", top: "-50px", left: "0"}}></div>
          {!shippingSpeed
          ?
            <Skeleton height={12} radius="xl" mb={10}></Skeleton>
          :
            <ShippingSpeed shippingSpeed={shippingSpeed} isOutsideUSA={isOutsideUSA} deliveryDate={deliveryDate} secondsToCutoff={secondsToCutoff}></ShippingSpeed>
          }
          {!zipCode
          ?
            <Skeleton height={12} radius="xl" mb={10}></Skeleton>
          :
            <Text size={13} >{"Delivering to "}

              <Popover width={200} position="bottom-end" withArrow shadow="md" opened={popOverOpened} onChange={setPopOverOpened}>
                <Popover.Target >
                  <UnstyledButton onClick={() => {
                    if(isMobile) {targetRef.current.scrollIntoView({ behavior: 'smooth' })}
                    setPopOverOpened((o) => !o)}
                    }>
                    <Location className="icon-tabler icon-tabler-location" stroke={'#000000'} size={14} style={{verticalAlign: "middle", paddingRight: "5", paddingBottom: 1}}></Location>
                    <span style={{fontSize: "13px", borderBottom: "solid black 1px"}}>{isOutsideUSA ? "Outside US" : zipCode}</span>
                    <ChevronDown className="icon-tabler icon-tabler-chevron-down" stroke={'#000000'} size={14} style={{verticalAlign: "middle"}} ></ChevronDown>
                  </UnstyledButton>
                </Popover.Target>
                <Popover.Dropdown style={{textAlign: "left"}} >
                  <Paper p={5} >
                  <form>
                    <Select 
                      label=<Text size="sm" align="left">Location</Text>
                      value={popOverCountry}
                      data={[
                        { value: 'usa', label: 'United States' },
                        { value: 'outsideUS', label: 'Outside U.S.' }
                      ]}
                      onChange={setPopOverCountry}
                    />
                    {popOverCountry === 'usa'
                    ?
                    <TextInput inputMode="numeric" error={/^\d{5}?$/.test(popOverZipCode) && popOverZipCode !== "00000" ? "" : "Enter a valid 5 digit zip code"} mt={10} label="Zip Code" value={popOverZipCode} onChange={(event) => setPopOverZipCode(event.currentTarget.value)}></TextInput>
                    :
                    null}
                    <Button type={"submit"} disabled={popOverCountry === "usa" && (/^\d{5}?$/.test(popOverZipCode) === false || popOverZipCode === "00000")} fullWidth mt={25} onClick={(e) => {handleSavePopOverInputs(e)}}>Save</Button>
                    </form>
                  </Paper>

                </Popover.Dropdown>
              </Popover>

              
            </Text>
          }
          
        </Paper>
      :
      null
      }
    </>
  );
}

export default App;
